export default "__VITE_ASSET__CY4kf5hi__"